//@ts-check
import React from 'react';
import CRM from './CRM';

var IntegrationsBootstrap = function IntegrationsBootstrap(_ref) {
  var children = _ref.children,
      history = _ref.history,
      id = _ref.id,
      crmPath = _ref.crmPath,
      crmLogPath = _ref.crmLogPath,
      crm = _ref.crm;
  if (!history) return children;
  var location = history.location;
  if (typeof location.pathname !== 'string') return children;

  if (crm && (location.pathname.startsWith(crmPath) || location.pathname.startsWith(crmLogPath))) {
    return (// eslint-disable-next-line react/jsx-pascal-case
      React.createElement(CRM, {
        id: id,
        history: history,
        location: location,
        logPath: crmLogPath
      })
    );
  }

  return children;
};

IntegrationsBootstrap.defaultProps = {
  id: 'Engage',
  crmPath: '/settings/integrations/crm',
  crmLogPath: '/settings/integrations/crm/log',
  crm: false
};
export default IntegrationsBootstrap;